<template>
	<section>
		<div class="split">
			<div class="top">
				<slot name="top" />
			</div>
			<div class="bottom">
				<slot name="bottom" />
			</div>
		</div>
	</section>
</template>

<style lang="css" scoped>
section div.split
{
	display: flex;
	flex-direction: column;
	box-sizing: border-box;
	height: 100%;
	gap: 2rem;
}

section div.split > div
{
	position: relative;
	width: 100%;
}

section div.split > div.top,
section div.split > div.bottom
{
	flex: 1;
}

section div.split > div.top :deep(div),
section div.split > div.bottom :deep(div)
{
	margin: 0 auto;
	max-width: 1160px;
	padding: 0 2rem;
	box-sizing: border-box;
}

section div.split > div.top :deep(div p),
section div.split > div.bottom :deep(div p)
{
	text-align-last: center;
}

section div.split > div:has(img),
section div.split > div:has(picture),
section div.split > div:has(video)
{
	flex: 1 50vh !important;
}

section div.split > div:has(img)::before,
section div.split > div:has(picture)::before,
section div.split > div:has(video)::before
{
	content: '';
	position: absolute;
	top: -1px;
	left: 0;
	width: 100%;
	height: 41px;
	overflow: hidden;
	background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1200 120' preserveAspectRatio='none'%3E%3Cpath d='M1200 120L0 16.48 0 0 1200 0 1200 120z' fill='%23faf9f6'%3E%3C/path%3E%3C/svg%3E");
	background-size: contain;
	background-position: bottom left;
}

section div.split > div:has(img)::after,
section div.split > div:has(picture)::after,
section div.split > div:has(video)::after
{
	content: '';
	position: absolute;
	bottom: -1px;
	left: 0;
	width: 100%;
	height: 41px;
	overflow: hidden;
	background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1200 120' preserveAspectRatio='none'%3E%3Cpath d='M1200 120L0 16.48 0 0 1200 0 1200 120z' fill='%23faf9f6'%3E%3C/path%3E%3C/svg%3E");
	background-size: contain;
	background-position: bottom left;
	transform: rotate(180deg);
}

section div.split > div:not(:has(img:only-child), :has(picture:only-child), :has(video:only-child))
{
	text-align: center;
	padding: 4rem 0;
}

section :deep(img),
section :deep(picture),
section :deep(video)
{
	display: block;
	width: 100%;
	height: 100%;
	object-fit: cover;
}

section :deep(h3)
{
	padding: 0 1.5rem;
}

@media screen and (max-width: 900px)
{
	section div.split > div.top :deep(div),
	section div.split > div.bottom :deep(div)	
	{
		padding: 0 1.2rem;
	}
}

@media screen and (max-width: 700px)
{
	section div.split > div:not(:has(img:only-child), :has(picture:only-child), :has(video:only-child))
	{
		padding: 1rem 0;
	}	
}
</style>